import { AlertResponse } from '@juvare/alert-ui/backend/features/alerts/types';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Settings } from '@juvare/platform-sdk-react/types';
import { Box, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
export const getTexasWizardStepData = (
    data: AlertResponse,
    settings: Settings,
    t: TFunction<'healthAlerts'>,
):
    | {
          title: React.ReactNode;
          header?: React.ReactNode;
          children: React.ReactNode;
      }
    | undefined => {
    const customAlertData = data.additionalData?.customAlertData ? JSON.parse(data.additionalData?.customAlertData) : {};
    const categoriesSetting = settings.notificationCategoryList;
    const category = categoriesSetting.find((item) => {
        return item.category.key === customAlertData.pcrCategory;
    });

    const subCategory = category?.subCategory.find((item) => {
        return item.key === customAlertData.pcrSubCategory;
    });

    if (!category || !subCategory) {
        return undefined;
    }

    return {
        title: t('forms.priorityCollection.subHeader'),
        children: (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    backgroundColor: themeColors.surface.secondary,
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '35% 65%',
                        p: 2,
                        backgroundColor: themeColors.surface.tertiary,
                        borderRadius: 1,
                    }}
                >
                    <Typography variant='body2'>{t('forms.priorityCollection.category')}</Typography>
                    <Typography variant='subtitle2'>{`${category?.category.key}. ${category?.category.value}`}</Typography>
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '35% 65%',
                        p: 2,
                        backgroundColor: themeColors.surface.tertiary,
                        borderRadius: 1,
                    }}
                >
                    <Typography variant='body2'>{t('forms.priorityCollection.subCategoryOther')}</Typography>
                    <Typography variant='subtitle2'>{`${subCategory?.key}. ${subCategory?.value}`}</Typography>
                </Box>
            </Box>
        ),
    };
};
